/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceMetadataDto
 */
export interface ServiceMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceMetadataDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceMetadataDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceMetadataDto
     */
    docsBaseUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceMetadataDto
     */
    baseUrl: string;
    /**
     * Follow semantic versioning
     * @type {string}
     * @memberof ServiceMetadataDto
     */
    apiVersion: string;
}

/**
 * Check if a given object implements the ServiceMetadataDto interface.
 */
export function instanceOfServiceMetadataDto(value: object): value is ServiceMetadataDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('docsBaseUrl' in value) || value['docsBaseUrl'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    if (!('apiVersion' in value) || value['apiVersion'] === undefined) return false;
    return true;
}

export function ServiceMetadataDtoFromJSON(json: any): ServiceMetadataDto {
    return ServiceMetadataDtoFromJSONTyped(json, false);
}

export function ServiceMetadataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'docsBaseUrl': json['docsBaseUrl'],
        'baseUrl': json['baseUrl'],
        'apiVersion': json['apiVersion'],
    };
}

export function ServiceMetadataDtoToJSON(json: any): ServiceMetadataDto {
    return ServiceMetadataDtoToJSONTyped(json, false);
}

export function ServiceMetadataDtoToJSONTyped(value?: ServiceMetadataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'docsBaseUrl': value['docsBaseUrl'],
        'baseUrl': value['baseUrl'],
        'apiVersion': value['apiVersion'],
    };
}

